import { ExampleFile } from "../models/exampleFile.types"

export const examinersImportJson: ExampleFile = {
  content: `[
        {
          "pesel": "96031206708",
          "imie": "Jan",
          "nazwisko": "Kowalski",
          "email": "jan.kowalsky@wp.pl",
          "telefonKomorkowy": "+48987654321",
          "idOke": "2"
        },
        {
          "pesel": "92080908622",
          "imie": "Helena",
          "nazwisko": "Majdaniec",
          "email": "jdaniels@wp.pl",
          "telefonKomorkowy": "+48123456789",
          "idOke": "2"
        }
      ]`,
  name: 'egzaminatorzy_konta.json',
  type: 'application/json'
}

export const examineeImportJson: ExampleFile = {
  content: `[
    {
      "id": "1234567",
      "pesel": "63041135773",
      "numerDokumentu": null,
      "kodZdajacego": null,
      "kodSzkoly": "c4180000-5d77-0015-c242-08d68b7b9dde",
      "rspoSzkoly": "1234567",
      "numerSali": null,
      "uprawnieniaDlaDostosowan": null,
      "sposobyDostosowan": null,
      "idDeklaracji": null
    }
  ]`,
  name: 'wykaz_zdajcych.json',
  type: 'application/json',
};

export const examineeImportJsonSIOEO: ExampleFile = {
  content: `[
    {
      "id": "1234567",
      "idOke": "1",
      "pesel": "63041135773",
      "numerDokumentu": null,
      "kodZdajacego": "A12",
      "kodSzkoly": "c4180000-5d77-0015-c242-08d68b7b9dde",
      "rspoSzkoly": "1234567",
      "numerSali": "Sala 10",
      "uprawnieniaDlaDostosowan": [
        1,
        3,
        6
      ],
      "sposobyDostosowan": [
        2,
        5
      ],
      "idDeklaracji": null
    }
  ]`,
  name: 'wykaz_zdajcych.json',
  type: 'application/json',
};

export const examineeImportJsonSIOEPKZ: ExampleFile = {
  content: `[
    {
      "id": "1234567",
      "idOke": "1",
      "pesel": "63041135773",
      "numerDokumentu": null,
      "kodZdajacego": null,
      "kodSzkoly": "c4180000-5d77-0015-c242-08d68b7b9dde",
      "rspoSzkoly": "1234567",
      "numerSali": null,
      "uprawnieniaDlaDostosowan": null,
      "sposobyDostosowan": null,
      "idDeklaracji": "c4180000-5d77-0015-c242-08d68b7b9dde"
    }
  ]`,
  name: 'wykaz_zdajcych.json',
  type: 'application/json',
};

export const adjustmentsImportJson: ExampleFile = {
  content: `{
        "typArkusza": [
          {
            "id": 1,
            "nazwa": "Standardowy",
            "kod": "100"
          },
          {
            "id": 2,
            "nazwa": "słabosłyszący",
            "kod": "400"
          }
        ],
        "uprawnieniaDlaDostosowan": [
          {
            "id": 1,
            "nazwa": "specyficzne trudności w uczeniu się - dyskalkulia"
          },
          {
            "id": 2,
            "nazwa": "niepełnosprawność ruchowa"
          }
        ],
        "sposobyDostosowania": [
          {
            "id": 1,
            "nazwa": "odczytanie tekstów dłuższych niż 250 słów przez CZN"
          },
          {
            "id": 2,
            "nazwa": "obecność specjalisty"
          }
        ]
      }`,
  name: 'import_dostosowan.json',
  type: 'application/json'
}

export const examinersTeamImportJson: ExampleFile = {
  content: `{
    "kod_arkusza": "OMAP-100",
    "GZ": [
      {
        "nazwaGZ": "GZ1",
        "ZE": [
          {
            "PZE": "84041209321",
            "nr_egz": "200329322",
            "Egzaminatorzy": [
              {
                "E": "72021209321",
                "nr_egz": "276538654"
              },
              {
                "E": "76061203299",
                "nr_egz": "200312345"
              },
              {
                "E": "81012220541",
                "nr_egz": "200329876"
              },
              {
                "E": "81012220541",
                "nr_egz": "200327777"
              }
            ]
          },
          {
            "PZE": "69041209321",
            "nr_egz": "200329322",
            "Egzaminatorzy": [
              {
                "E": "67021890098",
                "nr_egz": "200328888"
              },
              {
                "E": "76061203299",
                "nr_egz": "2841045623"
              },
              {
                "E": "81012220541",
                "nr_egz": "200329121"
              },
              {
                "E": "81012220541",
                "nr_egz": "203991921"
              }
            ]
          }
        ]
      },
      {
        "nazwaGZ": "GZ2",
        "ZE": [
          {
            "PZE": "78011209321",
            "nr_egz": "200329522",
            "Egzaminatorzy": [
              {
                "E": "74021209321",
                "nr_egz": "286538654"
              },
              {
                "E": "86061203299",
                "nr_egz": "200412345"
              },
              {
                "E": "87012220541",
                "nr_egz": "200829876"
              },
              {
                "E": "82012220541",
                "nr_egz": "200327877"
              }
            ]
          },
          {
            "PZE": "6904120933",
            "nr_egz": "200329322",
            "Egzaminatorzy": [
              {
                "E": "67031890098",
                "nr_egz": "200528888"
              },
              {
                "E": "77061203299",
                "nr_egz": "2741045623"
              },
              {
                "E": "81012220541",
                "nr_egz": "270329121"
              },
              {
                "E": "81012220541",
                "nr_egz": "273991921"
              }
            ]
          }
        ]
      }
    ]
  }`,
  name: 'egzaminatorzy_sklady.json',
  type: 'application/json'
}